import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const profile = initialState;

const slice = createSlice({
	name: "profile",
	initialState,
	reducers: {
		selectProfile: (state, action) => {
			let { menu } = action.payload;
			/**
			 * Save selected assistant in profile
			 */
			let selectedAssistant = {
				menu
			};

			state.selectedAssistant = selectedAssistant;
		},
		updateMenu: (state, action) => {
			const { menu } = action.payload;
			state.selectedAssistant.menu = menu;
		}
	}
});

const selectMenu = state => state.profile.selectedAssistant.menu;

export const selectCurrentProfile = state => state.profile;

export const selectNotificationsList = createSelector(
	[selectCurrentProfile, state => state.notifications],
	(profile, notifications) => {
		return notifications.list || [];
	}
);

export const selectAllSortedMenu = createSelector([selectMenu], menu => {
	return menu.filter(item => item.type === "route").sort((a, b) => a.rank - b.rank);
});

export const { selectProfile, updateMenu } = slice.actions;

export default slice.reducer;
